import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.recruitments.pipeline');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-recruitments-pipeline',
template: templateSource || '',
    styles: [``],
})
export class PageRecruitmentsPipelineComponent implements OnInit {
    public id: string = '';
    public loading: boolean = true;
    public board: any = null;
    public permissions: any = {
        can_view_board: false,
        can_change_ats_stage: false,
        permission: "ATS_STAGE_VIEW"
    };
    public uiPolicy: any = {
        solo_admin_mode: true,
        solo_admin_applies: false
    };
    public stageChanging: boolean = false;
    public stageModalOpen: boolean = false;
    public stageModalCard: any = null;
    public stageModalWarnings: any[] = [];
    public stageModalError: string = "";
    public stageChangeForm: any = {
        to_stage: "",
        reason: "",
        note: ""
    };
    public filters: any = {
        application_position: "",
        review_status: "",
        needs_attention: "",
        disqualification_candidate: ""
    };
    public positions: any[] = [
        { key: "", label: "전체" },
        { key: "EDUCATION_REGULAR", label: "교육담당 정규직" },
        { key: "ASSISTANT_CONTRACT", label: "업무보조 계약직" },
        { key: "UNKNOWN", label: "미확인" },
    ];
    public reviewStatuses: any[] = [
        { key: "", label: "전체" },
        { key: "NEEDS_HUMAN_REVIEW", label: "확인 필요" },
        { key: "REVIEW_IN_PROGRESS", label: "검토 중" },
        { key: "REVIEW_COMPLETED", label: "검토 완료" },
        { key: "QUEUED", label: "처리 대기" },
        { key: "FINALIZED", label: "담당자 확정" },
    ];
    public booleanFilters: any[] = [
        { key: "", label: "전체" },
        { key: "true", label: "있음" },
        { key: "false", label: "없음" },
    ];

    constructor(@Inject( Service) public service: Service) {
        this.id = WizRoute.segment.id;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.loadPermissions();
        await this.load();
    }

    public async loadPermissions() {
        const { code, data } = await wiz.call("get_board_permissions");
        if (code === 200 && data) {
            this.permissions = data;
            this.updateUiPolicy(data);
        }
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        if (!this.permissions.can_view_board) {
            this.loading = false;
            await this.service.render();
            return;
        }

        const { code, data, message } = await wiz.call("get_board", {
            id: this.id,
            recruitment_id: this.id,
            application_position: this.filters.application_position,
            review_status: this.filters.review_status,
            needs_attention: this.filters.needs_attention,
            disqualification_candidate: this.filters.disqualification_candidate
        });
        if (code === 200) {
            this.board = data;
            if (data?.permissions) this.permissions = { ...this.permissions, ...data.permissions };
            this.updateUiPolicy(data);
        } else {
            await this.service.modal.error(message || "ATS 칸반 보드 조회에 실패했습니다.");
        }

        this.loading = false;
        await this.service.render();
    }

    public async submitFilters() {
        await this.load();
    }

    public async resetFilters() {
        this.filters = {
            application_position: "",
            review_status: "",
            needs_attention: "",
            disqualification_candidate: ""
        };
        await this.load();
    }

    public columns() {
        return this.board?.columns || [];
    }

    public totalCount() {
        return this.board?.total_count || 0;
    }

    public canChangeStage() {
        return !!this.permissions?.can_change_ats_stage;
    }

    public updateUiPolicy(data: any) {
        const policy = data?.ui_policy || data?.permissions?.ui_policy || null;
        if (policy) this.uiPolicy = { ...this.uiPolicy, ...policy };
    }

    public soloAdminMode() {
        return !!this.uiPolicy?.solo_admin_mode && !!this.uiPolicy?.solo_admin_applies;
    }

    public compactStatusLabel(label: any) {
        const text = String(label || "").trim();
        if (!text) return "";
        if (text.includes("권한")) return text;
        if (/결격|disqual|fail/i.test(text)) return "결격 후보";
        if (/증빙|evidence|missing|누락/i.test(text)) return text.includes("불일치") ? "증빙 불일치" : "증빙 누락";
        if (/양식|form|오류/i.test(text)) return "양식 오류";
        if (/평가|score|needs_review/i.test(text)) return "평가 확인";
        if (/기준|룰|rubric/i.test(text)) return "기준 확인";
        if (/담당자 확인 필요|관리자 확인 필요|관리자 확정 필요|수동검토 필요|기준 확정 필요|심사위원 입력 필요/.test(text)) return "확인 필요";
        if (text.includes("자동 산정 초안")) return "초안";
        if (text.includes("최종 미확정")) return "미확정";
        if (text.includes("정성 대기")) return "대기";
        return text;
    }

    public cardReviewStatusLabel(card: any) {
        const label = card?.review_status_label || card?.review_status || "";
        return this.soloAdminMode() ? this.compactStatusLabel(label) : label;
    }

    public visibleWarningBadges(card: any) {
        const badges = card?.warning_badges || [];
        if (!this.soloAdminMode()) return badges;

        const compacted: any[] = [];
        const seen: any = {};
        for (const badge of badges) {
            const label = this.compactStatusLabel(badge?.label || badge?.message || badge?.code);
            if (!label || seen[label]) continue;
            seen[label] = true;
            compacted.push({ ...badge, label });
            if (compacted.length >= 2) break;
        }
        return compacted;
    }

    public hiddenWarningCount(card: any) {
        if (!this.soloAdminMode()) return 0;
        const total = (card?.warning_badges || []).length;
        return Math.max(0, total - this.visibleWarningBadges(card).length);
    }

    public cardScoreSummary(card: any) {
        const needsReview = card?.score_needs_review_count || 0;
        const score = card?.auto_score_label || 0;
        if (this.soloAdminMode()) return `평가 확인 ${needsReview}건 · 점수 ${score}`;
        return `평가 확인 ${needsReview}건 · 자동 초안 ${score}`;
    }

    public stageModalVisibleWarnings() {
        const warnings = this.stageModalWarnings || [];
        if (!this.soloAdminMode()) return warnings;
        return warnings.slice(0, 4).map((warning: any) => ({
            ...warning,
            label: this.compactStatusLabel(warning?.label || warning?.message || warning?.code)
        }));
    }

    public stageModalHiddenWarningCount() {
        if (!this.soloAdminMode()) return 0;
        return Math.max(0, (this.stageModalWarnings || []).length - this.stageModalVisibleWarnings().length);
    }

    public openDetail(card: any, event?: any) {
        if (event?.preventDefault) event.preventDefault();
        if (event?.stopPropagation) event.stopPropagation();
        if (!card?.detail_url) return;
        location.href = card.detail_url;
    }

    public openStageModal(card: any, event?: any) {
        if (event?.preventDefault) event.preventDefault();
        if (event?.stopPropagation) event.stopPropagation();
        this.stageModalCard = card;
        this.stageModalWarnings = card?.warning_badges || [];
        this.stageModalError = "";
        const next = (card?.stage_options || []).find((stage: any) => !stage.disabled) || null;
        this.stageChangeForm = {
            to_stage: next?.stage_key || "",
            reason: "",
            note: ""
        };
        this.stageModalOpen = true;
    }

    public closeStageModal(event?: any) {
        if (event?.preventDefault) event.preventDefault();
        if (event?.stopPropagation) event.stopPropagation();
        if (this.stageChanging) return;
        this.stageModalOpen = false;
        this.stageModalCard = null;
        this.stageModalWarnings = [];
        this.stageModalError = "";
        this.stageChangeForm = { to_stage: "", reason: "", note: "" };
    }

    public stageOptions() {
        return this.stageModalCard?.stage_options || [];
    }

    public selectedStage() {
        const key = this.stageChangeForm.to_stage;
        return this.stageOptions().find((stage: any) => stage.stage_key === key) || null;
    }

    public selectedStageLabel() {
        const stage = this.selectedStage();
        return stage?.stage_label || stage?.label || this.stageChangeForm.to_stage || "";
    }

    public selectedStageDisabled() {
        return !!this.selectedStage()?.disabled;
    }

    public selectedStageIsTerminal() {
        return !!this.selectedStage()?.is_terminal;
    }

    public modalWarningLabel(warning: any) {
        const label = warning?.message || warning?.label || warning?.code || "확인 필요 항목";
        return this.soloAdminMode() ? this.compactStatusLabel(label) : label;
    }

    public stageButtonLabel(card: any) {
        if (!this.canChangeStage()) return "권한 필요";
        if (!card?.can_change_stage) return "현재 단계에서 사용할 수 없음";
        return "단계 변경";
    }

    public async submitStageChange(event?: any) {
        if (event?.preventDefault) event.preventDefault();
        if (event?.stopPropagation) event.stopPropagation();
        if (this.stageChanging || !this.stageModalCard) return;
        this.stageModalError = "";

        if (!this.canChangeStage()) {
            this.stageModalError = "단계 변경 권한이 필요합니다.";
            return;
        }
        if (!this.stageChangeForm.to_stage || this.selectedStageDisabled()) {
            this.stageModalError = "이동할 수 없는 단계입니다.";
            return;
        }
        if (this.selectedStageIsTerminal() && !(this.stageChangeForm.reason || "").trim()) {
            this.stageModalError = "최종 단계 이동에는 사유가 필요합니다.";
            return;
        }

        this.stageChanging = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("change_stage", {
            applicant_id: this.stageModalCard.id,
            to_stage: this.stageChangeForm.to_stage,
            reason: this.stageChangeForm.reason || "",
            note: this.stageChangeForm.note || ""
        });
        this.stageChanging = false;

        if (code === 200 && data?.ok !== false) {
            this.closeStageModal();
            await this.load();
            return;
        }

        this.stageModalWarnings = data?.warnings || this.stageModalWarnings;
        this.stageModalError = this.safeStageError(code, message || data?.message);
        await this.service.render();
    }

    public safeStageError(code: number, message?: string) {
        if (code === 403) return "단계 변경 권한이 필요합니다.";
        if (code === 409) return "이동할 수 없는 단계입니다.";
        if (code === 400 && (message || "").includes("사유")) return "최종 단계 이동에는 사유가 필요합니다.";
        if (code >= 500) return "단계 변경 중 오류가 발생했습니다.";
        const text = String(message || "").trim();
        if (!text || /Traceback|File \"|\/opt\/|storage_key|file_path|<html/i.test(text)) return "단계 변경 중 오류가 발생했습니다.";
        return text.length > 120 ? `${text.slice(0, 120).trim()}...` : text;
    }

    public badgeClass(status: string) {
        status = status || "";
        if (status === "PERMISSION_REQUIRED") return "bg-zinc-50 text-zinc-600 border border-zinc-200";
        if (status === "NEEDS_REVIEW" || status === "NEEDS_HUMAN_REVIEW" || status === "MANUAL_REVIEW_REQUIRED" || status === "QUEUED") return "bg-amber-50 text-amber-700 border border-amber-200";
        if (status === "REVIEW_COMPLETED" || status === "MATCHED" || status === "PASS" || status === "PASS_CANDIDATE") return "bg-emerald-50 text-emerald-700 border border-emerald-200";
        if (status === "REVIEW_IN_PROGRESS" || status === "PROCESSING") return "bg-sky-50 text-sky-700 border border-sky-200";
        if (status === "FINAL_ACCEPTED") return "bg-emerald-50 text-emerald-700 border border-emerald-200";
        if (status === "REJECTED" || status === "FAIL_CANDIDATE") return "bg-rose-50 text-rose-700 border border-rose-200";
        return "bg-zinc-50 text-zinc-600 border border-zinc-200";
    }
}

export default PageRecruitmentsPipelineComponent;